import {
  CREATE_GIFT_CARD,
  GET_ALL_GIFT_CARD,
  GET_GIFT_CARD_DETAILS,
  UPDATE_PAYMENT_MODES,
} from '../constants/urls';
import zfetch, { METHOD_GET, METHOD_POST } from '../pages/common/utils/zfetch';

const getAllGiftCards = data => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(data),
  };

  return zfetch(GET_ALL_GIFT_CARD, options).then(res => res.json());
};

const updatePaymentModes = data => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(data),
  };

  return zfetch(UPDATE_PAYMENT_MODES, options).then(res => res.json());
};

const getGiftCardDetails = referenceId => {
  const options = {
    method: METHOD_GET,
    params: { reference_id: referenceId },
  };

  return zfetch(GET_GIFT_CARD_DETAILS, options).then(res => res.json());
};

const createGiftCard = data => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(data),
  };

  return zfetch(CREATE_GIFT_CARD, options).then(res => res.json());
};

export {
  getAllGiftCards,
  updatePaymentModes,
  getGiftCardDetails,
  createGiftCard,
};
